import type { DriveStep } from 'driver.js';

export const attorneyCasesSteps: DriveStep[] = [
  {
    element: '[data-tour="attorney-cases-new"]',
    popover: {
      title: 'Create a Case',
      description:
        'Start a new case manually or import one. Accepted intake requests auto-create cases.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-cases-search"]',
    popover: {
      title: 'Search and Filter',
      description: 'Find cases by title, doctor, or status.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-cases-table"]',
    popover: {
      title: 'Your Case List',
      description:
        'Click to open detail view with tabs for appointments, deliverables, invoices, files, and notes.',
      side: 'top',
      align: 'center',
    },
  },
];
